unit View.Cupons.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils, UFrameDataBase, Vcl.Forms, XData.Web.Client,
  System.StrUtils, UPersonalizacao_Tabela, UPersonalizacao_Tabela.Interfaces,
  UHelperServer, System.DateUtils;

type
  TFViewCuponsList = class(TForm)
    CuponsDataset: TXDataWebDataSet;
    CuponsDatasetid: TIntegerField;
    CuponsDatasetcaixa: TIntegerField;
    CuponsDatasetnumero: TStringField;
    CuponsDatasetdata_emissao: TDateTimeField;
    CuponsDatasetdata_saida: TDateTimeField;
    CuponsDatasetvalor_total: TFloatField;
    CuponsDatasetcodigo_interno: TIntegerField;
    CuponsDatasetexcluido: TBooleanField;
    CuponsDatasetinclusao: TDateTimeField;
    CuponsDatasetalteracao: TDateTimeField;
    CuponsDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    btnExportarExcel: TButton;
    edtDataInicial: TDateTimePicker;
    edtDataFinal: TDateTimePicker;
    cbxCuponsExcluidos: TCheckBox;
    edtClienteNome: TEdit;
    btnPesquisarCliente: TButton;
    cbbCuponsNfce: TComboBox;
    frmBanco: TfrmDataBase;
    btnPesquisarCupom: TButton;
    XDataWebClient: TXDataWebClient;
    CuponsDatasetnfce_id: TIntegerField;
    CuponsDatasetnfcenfce_xml_s3: TStringField;
    CuponsDatasetnfcechave_acesso: TStringField;
    CuponsDatasetfuncionarionome: TStringField;
    CuponsDatasetclienterazao_social_nome: TStringField;
    CuponsDatasetnfceanexo_sincronizado: TXDataWebDatasetField;
    cbxCuponsCancelados: TCheckBox;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure btnPesquisarCupomClick(Sender: TObject);
    procedure btnPesquisarClienteClick(Sender: TObject);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure XDataWebClientError(Error: TXDataClientError);
    procedure XDataWebClientLoad(Response: TXDataClientResponse);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    procedure ConfigurarData;
    function GetFiltro : string;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewCuponsList: TFViewCuponsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCuponsList }

procedure TFViewCuponsList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(CuponsDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewCuponsList.btnPesquisarClienteClick(Sender: TObject);
begin
  THelperServer.ChamarConsulta('Clientes', 'clientes', edtClienteNome);
end;

procedure TFViewCuponsList.btnPesquisarCupomClick(Sender: TObject);
var
  lDataInvalida : string;
begin
  lDataInvalida := THelperServer.ValidarDatasMovimentos(edtDataInicial.Text, edtDataFinal.Text);

  if not lDataInvalida.IsEmpty then
  begin
    TUtils.ChamarMensagemDialog(TTipoDialogo.INFORMACAO, lDataInvalida);
    Exit;
  end;

  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCuponsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewCuponsList.ConfigurarData;
begin
  edtDataFinal.Max := Date;
  edtDataInicial.Min := IncDay(Date, -365);
  edtDataInicial.Date := IncDay(Date, -365);
  edtDataFinal.Date := Date;
end;

class function TFViewCuponsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCuponsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewCuponsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewCuponsList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewCuponsList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

function TFViewCuponsList.GetFiltro: string;
var
  lListaFiltro : TStringList;
  lFiltroBanco : string;
begin
  Result := EmptyStr;
  lListaFiltro := TStringList.Create;

  try
    if not cbxCuponsExcluidos.Checked then
      lListaFiltro.Add('(excluido eq false)');

    if not cbxCuponsCancelados.Checked then
      lListaFiltro.Add('(cupom_cancelado eq false)');

    if edtClienteNome.Tag <> 0 then
      lListaFiltro.Add('(cliente_id eq '+edtClienteNome.Tag.ToString+')');

    if ((edtDataInicial.Text <> '') and (edtDataFinal.Text <> '')) then
    begin
      lListaFiltro.Add('((data_emissao ge '+edtDataInicial.Text+') and ' +
        '(data_emissao le '+edtDataFinal.Text+'))');
    end;

    lFiltroBanco := frmBanco.GetFilterDataBase;

    if not lFiltroBanco.IsEmpty then
      lListaFiltro.Add('(data_base_id eq '+lFiltroBanco+')');

    case cbbCuponsNfce.ItemIndex of
      1: lListaFiltro.Add('(nfce_id ne null)');
      2: lListaFiltro.Add('(nfce_id eq null)');
    end;

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewCuponsList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewCuponsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordNfceId,
  RecordCupomId : Integer;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure BaixarArquivoButtonClick(Sender: TObject);
  var
    lBotaoSelecionado : TButton;
    lJson : TJSObject;
    lBotaoNome : string;
  begin
    TUtils.ChamarDivLoading;

    lBotaoSelecionado := TButton(Sender);
    lBotaoNome := lBotaoSelecionado.Name;

    lJson := TJSObject.New;

    if lBotaoNome = 'rbtBaixarXml'  then
      lJson['tipo'] := 'xml'
    else if lBotaoNome = 'rbtBaixarDanfe' then
      lJson['tipo'] := 'danfe'
    else
    begin
      lJson['tabela'] := 'cupons';
      lJson['tipo'] := 'relatorio'
    end;

    lJson['codigo'] := lBotaoSelecionado.Tag;

    if lBotaoNome <> 'rbtBaixarRelatorio' then
      lJson['tabela'] := 'nfce';

    XDataWebClient.RawInvoke('IService.BaixarArquivo', [lJson]);
  end;

var
  Button: TButton;
  lHabilitarDanfeXml : Boolean;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      CuponsDataset.Connection.Model.DefaultSchema.FindEntityType(CuponsDataset.EntitySetName),
      CuponsDataset.CurrentData
    );

    RecordNfceId := CuponsDataset.FieldByName('nfce_id').AsInteger;
    RecordCupomId := CuponsDataset.FieldByName('id').AsInteger;

    lHabilitarDanfeXml := not CuponsDataset.FieldByName('nfce.nfce_xml_s3').AsString.IsEmpty and
      (CuponsDataset.FieldByName('nfce.anexo_sincronizado').AsString = '1');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_cupom');

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarXml';
    Button.Tag := RecordNfceId;
    Button.Caption := '<i class="fas fa-file-code"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_xml');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-secondary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar XML');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarDanfe';
    Button.Tag := RecordNfceId;
    Button.Caption := '<i class="fas fa-file-pdf"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_danfe');

    if lHabilitarDanfeXml then
    begin
      Button.OnClick := @BaixarArquivoButtonClick;
      Button.ElementClassName := 'btn btn-link btn-danger btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Baixar Danfe');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;

    Button := TButton.Create(nil);
    Button.Name := 'rbtBaixarRelatorio';
    Button.Tag := RecordCupomId;
    Button.Caption := '<i class="fas fa-file-alt"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_baixar_relatorio');
    Button.OnClick := @BaixarArquivoButtonClick;
    Button.ElementClassName := 'btn btn-link btn-info btn-lg';
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Baixar Relatório');
  end;
end;

procedure TFViewCuponsList.WebDBTableControl1GetCellClass(Sender: TObject; ACol,
  ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['numero', 'funcionario.nome',
     'cliente.razao_social_nome', 'valor_total']) of
      0, 1, 2: AClassName := 'text-start';
      3: AClassName := 'text-end'
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewCuponsList.WebDBTableControl1GetCellData(Sender: TObject; ACol,
  ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['excluido']) of
     0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>';
      end;
    end;
  end;
end;

procedure TFViewCuponsList.WebFormCreate(Sender: TObject);
begin
  ConfigurarData;
  frmBanco.ConfigurarDataBase;

  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('cupons', 'active');
  TUtils.SetValorDicionarioClasses('vendas_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_vendas', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, CuponsDataset, lcPaginator,
    lbPaginationInfo);
  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'codigo_interno desc';
  FGridPlugin.FDatasetPlugin.FFilterPadrao := GetFiltro;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewCuponsList.XDataWebClientError(Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewCuponsList.XDataWebClientLoad(Response: TXDataClientResponse);
var
  lJSONObject: TJSObject;
begin
  lJSONObject := Response.ResultAsObject;
  THelperServer.BaixarAnexo(string(lJSONObject['arquivo_base64']), string(lJSONObject['arquivo_nome']));
end;
procedure TFViewCuponsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.cupons.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.cupons.list.table');
  cbPageSize := TComboBox.Create('view.cupons.list.cbPageSize');
  edSearch := TEdit.Create('view.cupons.list.search');
  lcPaginator := TListControl.Create('view.cupons.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  edtDataInicial := TDateTimePicker.Create('edtDataInicial');
  edtDataFinal := TDateTimePicker.Create('edtDataFinal');
  cbxCuponsExcluidos := TCheckBox.Create('cbxCuponsExcluidos');
  edtClienteNome := TEdit.Create('edtClienteNome');
  btnPesquisarCliente := TButton.Create('btnPesquisarCliente');
  cbbCuponsNfce := TComboBox.Create('cbbCuponsNfce');
  frmBanco := TfrmDataBase.Create(Self);
  btnPesquisarCupom := TButton.Create('btnPesquisarCupom');
  cbxCuponsCancelados := TCheckBox.Create('cbxCuponsCancelados');
  CuponsDataset := TXDataWebDataSet.Create(Self);
  CuponsDatasetcodigo_interno := TIntegerField.Create(Self);
  CuponsDatasetnumero := TStringField.Create(Self);
  CuponsDatasetclienterazao_social_nome := TStringField.Create(Self);
  CuponsDatasetdata_emissao := TDateTimeField.Create(Self);
  CuponsDatasetdata_saida := TDateTimeField.Create(Self);
  CuponsDatasetvalor_total := TFloatField.Create(Self);
  CuponsDatasetcaixa := TIntegerField.Create(Self);
  CuponsDatasetfuncionarionome := TStringField.Create(Self);
  CuponsDatasetnfcechave_acesso := TStringField.Create(Self);
  CuponsDatasetexcluido := TBooleanField.Create(Self);
  CuponsDatasetinclusao := TDateTimeField.Create(Self);
  CuponsDatasetalteracao := TDateTimeField.Create(Self);
  CuponsDatasetexclusao := TDateTimeField.Create(Self);
  CuponsDatasetid := TIntegerField.Create(Self);
  CuponsDatasetnfce_id := TIntegerField.Create(Self);
  CuponsDatasetnfcenfce_xml_s3 := TStringField.Create(Self);
  CuponsDatasetnfceanexo_sincronizado := TXDataWebDatasetField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataWebClient := TXDataWebClient.Create(Self);

  frmBanco.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  edtDataInicial.BeforeLoadDFMValues;
  edtDataFinal.BeforeLoadDFMValues;
  cbxCuponsExcluidos.BeforeLoadDFMValues;
  edtClienteNome.BeforeLoadDFMValues;
  btnPesquisarCliente.BeforeLoadDFMValues;
  cbbCuponsNfce.BeforeLoadDFMValues;
  frmBanco.BeforeLoadDFMValues;
  frmBanco.cbbDataBasePesquisa.BeforeLoadDFMValues;
  btnPesquisarCupom.BeforeLoadDFMValues;
  cbxCuponsCancelados.BeforeLoadDFMValues;
  CuponsDataset.BeforeLoadDFMValues;
  CuponsDatasetcodigo_interno.BeforeLoadDFMValues;
  CuponsDatasetnumero.BeforeLoadDFMValues;
  CuponsDatasetclienterazao_social_nome.BeforeLoadDFMValues;
  CuponsDatasetdata_emissao.BeforeLoadDFMValues;
  CuponsDatasetdata_saida.BeforeLoadDFMValues;
  CuponsDatasetvalor_total.BeforeLoadDFMValues;
  CuponsDatasetcaixa.BeforeLoadDFMValues;
  CuponsDatasetfuncionarionome.BeforeLoadDFMValues;
  CuponsDatasetnfcechave_acesso.BeforeLoadDFMValues;
  CuponsDatasetexcluido.BeforeLoadDFMValues;
  CuponsDatasetinclusao.BeforeLoadDFMValues;
  CuponsDatasetalteracao.BeforeLoadDFMValues;
  CuponsDatasetexclusao.BeforeLoadDFMValues;
  CuponsDatasetid.BeforeLoadDFMValues;
  CuponsDatasetnfce_id.BeforeLoadDFMValues;
  CuponsDatasetnfcenfce_xml_s3.BeforeLoadDFMValues;
  CuponsDatasetnfceanexo_sincronizado.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataWebClient.BeforeLoadDFMValues;
  try
    Name := 'FViewCuponsList';
    Width := 695;
    Height := 299;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 232;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 30;
    WebDBTableControl1.Width := 305;
    WebDBTableControl1.Height := 187;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 200;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero';
      Title := 'Documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cliente.razao_social_nome';
      Title := 'Cliente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_emissao';
      Title := 'Emiss'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_saida';
      Title := 'Sa'#237'da';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'Valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'caixa';
      Title := 'caixa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario.nome';
      Title := 'Funcion'#225'rio';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 3;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 192;
    edSearch.Top := 3;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 152;
    lcPaginator.Top := 232;
    lcPaginator.Width := 161;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 352;
    btnExportarExcel.Top := 11;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    edtDataInicial.SetParentComponent(Self);
    edtDataInicial.Name := 'edtDataInicial';
    edtDataInicial.Left := 352;
    edtDataInicial.Top := 42;
    edtDataInicial.Width := 120;
    edtDataInicial.Height := 22;
    edtDataInicial.BorderStyle := bsSingle;
    edtDataInicial.ChildOrder := 109;
    edtDataInicial.Color := clWhite;
    edtDataInicial.Date := 45980.718362395830000000;
    edtDataInicial.Role := '';
    edtDataInicial.Text := '';
    edtDataFinal.SetParentComponent(Self);
    edtDataFinal.Name := 'edtDataFinal';
    edtDataFinal.Left := 352;
    edtDataFinal.Top := 70;
    edtDataFinal.Width := 120;
    edtDataFinal.Height := 22;
    edtDataFinal.BorderStyle := bsSingle;
    edtDataFinal.ChildOrder := 109;
    edtDataFinal.Color := clWhite;
    edtDataFinal.Date := 45980.718362395830000000;
    edtDataFinal.Role := '';
    edtDataFinal.Text := '';
    cbxCuponsExcluidos.SetParentComponent(Self);
    cbxCuponsExcluidos.Name := 'cbxCuponsExcluidos';
    cbxCuponsExcluidos.Left := 494;
    cbxCuponsExcluidos.Top := 70;
    cbxCuponsExcluidos.Width := 151;
    cbxCuponsExcluidos.Height := 22;
    cbxCuponsExcluidos.Caption := 'Exibir Exclu'#237'dos?';
    cbxCuponsExcluidos.ChildOrder := 9;
    cbxCuponsExcluidos.HeightPercent := 100.000000000000000000;
    cbxCuponsExcluidos.WidthPercent := 100.000000000000000000;
    edtClienteNome.SetParentComponent(Self);
    edtClienteNome.Name := 'edtClienteNome';
    edtClienteNome.Left := 494;
    edtClienteNome.Top := 42;
    edtClienteNome.Width := 120;
    edtClienteNome.Height := 22;
    edtClienteNome.ChildOrder := 21;
    edtClienteNome.Enabled := False;
    edtClienteNome.HeightPercent := 100.000000000000000000;
    edtClienteNome.WidthPercent := 100.000000000000000000;
    btnPesquisarCliente.SetParentComponent(Self);
    btnPesquisarCliente.Name := 'btnPesquisarCliente';
    btnPesquisarCliente.Left := 615;
    btnPesquisarCliente.Top := 42;
    btnPesquisarCliente.Width := 30;
    btnPesquisarCliente.Height := 22;
    btnPesquisarCliente.ChildOrder := 22;
    btnPesquisarCliente.HeightPercent := 100.000000000000000000;
    btnPesquisarCliente.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCliente, Self, 'OnClick', 'btnPesquisarClienteClick');
    cbbCuponsNfce.SetParentComponent(Self);
    cbbCuponsNfce.Name := 'cbbCuponsNfce';
    cbbCuponsNfce.Left := 352;
    cbbCuponsNfce.Top := 101;
    cbbCuponsNfce.Width := 120;
    cbbCuponsNfce.Height := 21;
    cbbCuponsNfce.HeightPercent := 100.000000000000000000;
    cbbCuponsNfce.Text := 'TODOS';
    cbbCuponsNfce.WidthPercent := 100.000000000000000000;
    cbbCuponsNfce.ItemIndex := 0;
    cbbCuponsNfce.Items.BeginUpdate;
    try
      cbbCuponsNfce.Items.Clear;
      cbbCuponsNfce.Items.Add('TODOS');
      cbbCuponsNfce.Items.Add('SIM');
      cbbCuponsNfce.Items.Add('N'#195'O');
    finally
      cbbCuponsNfce.Items.EndUpdate;
    end;
    frmBanco.SetParentComponent(Self);
    frmBanco.Name := 'frmBanco';
    frmBanco.Left := 352;
    frmBanco.Top := 134;
    frmBanco.Width := 215;
    frmBanco.Height := 61;
    frmBanco.TabOrder := 11;
    frmBanco.Visible := False;
    frmBanco.cbbDataBasePesquisa.Height := 21;
    btnPesquisarCupom.SetParentComponent(Self);
    btnPesquisarCupom.Name := 'btnPesquisarCupom';
    btnPesquisarCupom.Left := 352;
    btnPesquisarCupom.Top := 228;
    btnPesquisarCupom.Width := 96;
    btnPesquisarCupom.Height := 25;
    btnPesquisarCupom.Caption := 'Pesquisar';
    btnPesquisarCupom.ChildOrder := 11;
    btnPesquisarCupom.HeightPercent := 100.000000000000000000;
    btnPesquisarCupom.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarCupom, Self, 'OnClick', 'btnPesquisarCupomClick');
    cbxCuponsCancelados.SetParentComponent(Self);
    cbxCuponsCancelados.Name := 'cbxCuponsCancelados';
    cbxCuponsCancelados.Left := 494;
    cbxCuponsCancelados.Top := 98;
    cbxCuponsCancelados.Width := 151;
    cbxCuponsCancelados.Height := 22;
    cbxCuponsCancelados.Caption := 'Exibir Cancelados?';
    cbxCuponsCancelados.ChildOrder := 9;
    cbxCuponsCancelados.HeightPercent := 100.000000000000000000;
    cbxCuponsCancelados.WidthPercent := 100.000000000000000000;
    CuponsDataset.SetParentComponent(Self);
    CuponsDataset.Name := 'CuponsDataset';
    CuponsDataset.EntitySetName := 'Cupons';
    CuponsDataset.Connection := DMConnection.ApiConnection;
    CuponsDataset.Left := 72;
    CuponsDataset.Top := 80;
    CuponsDatasetcodigo_interno.SetParentComponent(CuponsDataset);
    CuponsDatasetcodigo_interno.Name := 'CuponsDatasetcodigo_interno';
    CuponsDatasetcodigo_interno.FieldName := 'codigo_interno';
    CuponsDatasetcodigo_interno.Required := True;
    CuponsDatasetnumero.SetParentComponent(CuponsDataset);
    CuponsDatasetnumero.Name := 'CuponsDatasetnumero';
    CuponsDatasetnumero.FieldName := 'numero';
    CuponsDatasetnumero.Required := True;
    CuponsDatasetnumero.Size := 255;
    CuponsDatasetclienterazao_social_nome.SetParentComponent(CuponsDataset);
    CuponsDatasetclienterazao_social_nome.Name := 'CuponsDatasetclienterazao_social_nome';
    CuponsDatasetclienterazao_social_nome.FieldName := 'cliente.razao_social_nome';
    CuponsDatasetdata_emissao.SetParentComponent(CuponsDataset);
    CuponsDatasetdata_emissao.Name := 'CuponsDatasetdata_emissao';
    CuponsDatasetdata_emissao.FieldName := 'data_emissao';
    CuponsDatasetdata_emissao.Required := True;
    CuponsDatasetdata_emissao.DisplayFormat := 'dd/mm/yy';
    CuponsDatasetdata_saida.SetParentComponent(CuponsDataset);
    CuponsDatasetdata_saida.Name := 'CuponsDatasetdata_saida';
    CuponsDatasetdata_saida.FieldName := 'data_saida';
    CuponsDatasetdata_saida.DisplayFormat := 'dd/mm/yy';
    CuponsDatasetvalor_total.SetParentComponent(CuponsDataset);
    CuponsDatasetvalor_total.Name := 'CuponsDatasetvalor_total';
    CuponsDatasetvalor_total.FieldName := 'valor_total';
    CuponsDatasetvalor_total.Required := True;
    CuponsDatasetvalor_total.DisplayFormat := '#,##0.00';
    CuponsDatasetcaixa.SetParentComponent(CuponsDataset);
    CuponsDatasetcaixa.Name := 'CuponsDatasetcaixa';
    CuponsDatasetcaixa.FieldName := 'caixa';
    CuponsDatasetfuncionarionome.SetParentComponent(CuponsDataset);
    CuponsDatasetfuncionarionome.Name := 'CuponsDatasetfuncionarionome';
    CuponsDatasetfuncionarionome.FieldName := 'funcionario.nome';
    CuponsDatasetnfcechave_acesso.SetParentComponent(CuponsDataset);
    CuponsDatasetnfcechave_acesso.Name := 'CuponsDatasetnfcechave_acesso';
    CuponsDatasetnfcechave_acesso.Tag := 3;
    CuponsDatasetnfcechave_acesso.FieldName := 'nfce.chave_acesso';
    CuponsDatasetexcluido.SetParentComponent(CuponsDataset);
    CuponsDatasetexcluido.Name := 'CuponsDatasetexcluido';
    CuponsDatasetexcluido.FieldName := 'excluido';
    CuponsDatasetinclusao.SetParentComponent(CuponsDataset);
    CuponsDatasetinclusao.Name := 'CuponsDatasetinclusao';
    CuponsDatasetinclusao.FieldName := 'inclusao';
    CuponsDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetalteracao.SetParentComponent(CuponsDataset);
    CuponsDatasetalteracao.Name := 'CuponsDatasetalteracao';
    CuponsDatasetalteracao.FieldName := 'alteracao';
    CuponsDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetexclusao.SetParentComponent(CuponsDataset);
    CuponsDatasetexclusao.Name := 'CuponsDatasetexclusao';
    CuponsDatasetexclusao.FieldName := 'exclusao';
    CuponsDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    CuponsDatasetid.SetParentComponent(CuponsDataset);
    CuponsDatasetid.Name := 'CuponsDatasetid';
    CuponsDatasetid.Tag := 1;
    CuponsDatasetid.FieldName := 'id';
    CuponsDatasetid.Required := True;
    CuponsDatasetnfce_id.SetParentComponent(CuponsDataset);
    CuponsDatasetnfce_id.Name := 'CuponsDatasetnfce_id';
    CuponsDatasetnfce_id.Tag := 1;
    CuponsDatasetnfce_id.FieldName := 'nfce_id';
    CuponsDatasetnfcenfce_xml_s3.SetParentComponent(CuponsDataset);
    CuponsDatasetnfcenfce_xml_s3.Name := 'CuponsDatasetnfcenfce_xml_s3';
    CuponsDatasetnfcenfce_xml_s3.Tag := 1;
    CuponsDatasetnfcenfce_xml_s3.FieldName := 'nfce.nfce_xml_s3';
    CuponsDatasetnfceanexo_sincronizado.SetParentComponent(CuponsDataset);
    CuponsDatasetnfceanexo_sincronizado.Name := 'CuponsDatasetnfceanexo_sincronizado';
    CuponsDatasetnfceanexo_sincronizado.Tag := 1;
    CuponsDatasetnfceanexo_sincronizado.FieldName := 'nfce.anexo_sincronizado';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := CuponsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 136;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 176;
    tmrConsulta.Top := 96;
    XDataWebClient.SetParentComponent(Self);
    XDataWebClient.Name := 'XDataWebClient';
    XDataWebClient.Connection := DMConnection.ApiConnection;
    SetEvent(XDataWebClient, Self, 'OnLoad', 'XDataWebClientLoad');
    SetEvent(XDataWebClient, Self, 'OnError', 'XDataWebClientError');
    XDataWebClient.Left := 600;
    XDataWebClient.Top := 128;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    edtDataInicial.AfterLoadDFMValues;
    edtDataFinal.AfterLoadDFMValues;
    cbxCuponsExcluidos.AfterLoadDFMValues;
    edtClienteNome.AfterLoadDFMValues;
    btnPesquisarCliente.AfterLoadDFMValues;
    cbbCuponsNfce.AfterLoadDFMValues;
    frmBanco.AfterLoadDFMValues;
    frmBanco.cbbDataBasePesquisa.AfterLoadDFMValues;
    btnPesquisarCupom.AfterLoadDFMValues;
    cbxCuponsCancelados.AfterLoadDFMValues;
    CuponsDataset.AfterLoadDFMValues;
    CuponsDatasetcodigo_interno.AfterLoadDFMValues;
    CuponsDatasetnumero.AfterLoadDFMValues;
    CuponsDatasetclienterazao_social_nome.AfterLoadDFMValues;
    CuponsDatasetdata_emissao.AfterLoadDFMValues;
    CuponsDatasetdata_saida.AfterLoadDFMValues;
    CuponsDatasetvalor_total.AfterLoadDFMValues;
    CuponsDatasetcaixa.AfterLoadDFMValues;
    CuponsDatasetfuncionarionome.AfterLoadDFMValues;
    CuponsDatasetnfcechave_acesso.AfterLoadDFMValues;
    CuponsDatasetexcluido.AfterLoadDFMValues;
    CuponsDatasetinclusao.AfterLoadDFMValues;
    CuponsDatasetalteracao.AfterLoadDFMValues;
    CuponsDatasetexclusao.AfterLoadDFMValues;
    CuponsDatasetid.AfterLoadDFMValues;
    CuponsDatasetnfce_id.AfterLoadDFMValues;
    CuponsDatasetnfcenfce_xml_s3.AfterLoadDFMValues;
    CuponsDatasetnfceanexo_sincronizado.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataWebClient.AfterLoadDFMValues;
  end;
end;

end.
